<script lang="ts" setup>
  import LoadingButtonRed from '~/assets/animations/loading-button-red.json'
  import LoadingButtonLight from '~/assets/animations/loading-button-light.json'
  import LoadingButtonDark from '~/assets/animations/loading-button-dark.json'
  import { Vue3Lottie } from 'vue3-lottie'

  const props = withDefaults(
    defineProps<{
      size?: 'sm' | 'md' | 'lg' | 'xl'
      color?: 'light' | 'dark' | 'red'
    }>(),
    {
      size: 'sm',
      color: 'dark'
    }
  )

  const animationData = computed(() => {
    switch (props.color) {
      case 'light':
        return LoadingButtonLight
      case 'dark':
        return LoadingButtonDark
      case 'red':
        return LoadingButtonRed
      default:
        return LoadingButtonLight
    }
  })

  const height = computed(() => {
    switch (props.size) {
      case 'sm':
        return 24
      case 'md':
        return 48
      case 'lg':
        return 96
      case 'xl':
        return 160
      default:
        return 48
    }
  })

  const width = computed(() => {
    switch (props.size) {
      case 'sm':
        return 24
      case 'md':
        return 48
      case 'lg':
        return 96
      case 'xl':
        return 160
      default:
        return 48
    }
  })
</script>

<template>
  <Vue3Lottie :animation-data="animationData" :height="height" :width="width" class="animation" />
</template>

<style lang="scss" scoped>
  .animation {
    display: block;
    margin: 0px 12px 0px 0px;
  }
</style>
